export function TenancyLengthSectionSkeleton() {
  return (
    <div className="w-full md:px-4 px-2">
      <div className="h-7 w-[420px] max-w-full rounded bg-secondary" />
      <div className="mt-2 h-4 w-40 rounded bg-secondary" />
      <div className="mt-6 h-16 rounded-2xl bg-secondary" />
      <div className="mt-6 space-y-6">
        <div className="h-12 rounded bg-secondary" />
        <div className="h-12 rounded bg-secondary" />
      </div>
    </div>
  );
}
